import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

export const Container = styled.div`
  margin: var(--spacing-06) 0;
`;

export const Title = styled.p`
  margin-bottom: 0;
  ${ProductiveHeading07};
`;

export const VerifiedText = styled(Title)<{ verified?: boolean }>`
  font-weight: bold;
  color: ${(props) => (props.verified ? 'var(--green-50)' : 'var(--gray-40)')};
`;
